import React, { type ComponentProps, useMemo } from 'react';
import { Tabs } from 'expo-router';
import { theme, useResponsive } from '@sg/garnish';

import { Navbar } from '../../components';

// ─────────────────────────────────────────────────────────────────────────────

export default function TabsLayout() {
  const { currentBreakpoint } = useResponsive();

  // ─────────────────────────────────────────────────────────────────────

  const screenOptions = useMemo<TabsScreenOptions>(
    () => ({
      headerShown: !currentBreakpoint.isXS,
      header: currentBreakpoint.isXS ? undefined : renderNavbar,
      sceneContainerStyle: { backgroundColor: theme.colors.APP_BACKGROUND },
    }),
    [currentBreakpoint.isXS],
  );

  // ─────────────────────────────────────────────────────────────────────

  return (
    <Tabs screenOptions={screenOptions} tabBar={hideTabBar}>
      <Tabs.Screen name="(menu)" />
    </Tabs>
  );
}

// ─── Helpers ─────────────────────────────────────────────────────────────────

function renderNavbar() {
  return <Navbar />;
}

function hideTabBar() {
  return null;
}

// ─── Types ───────────────────────────────────────────────────────────────────

type TabsScreenOptions = NonNullable<
  ComponentProps<typeof Tabs>['screenOptions']
>;
